import { App } from "./App";

import "./assets/stylesheets/app.scss";

new App();